import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { useMonitoring } from '../context/MonitoringContext';
import { normalizeRole } from '../utils/roles';

const MonitoringGate = ({ children }) => {
  const { user, isAuthenticated, loading: authLoading } = useAuth();
  const { disabled, loaded } = useMonitoring();

  if (authLoading || !loaded) return null;
  if (!isAuthenticated) return children;

  if (disabled && normalizeRole(user?.role) === 'client') {
    return <Navigate to="/bill" replace />;
  }
  return children;
};

export default MonitoringGate;
